// import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import { useSetMapLocation } from '../common/redux/hooks'
import { useDoModal } from '../user/redux/doModal'
import { path } from 'ramda'
import { userCanSocialPost, getMapLocationLabel, getDeviceSlug } from '../../common/ambient'
import { LocationAutocomplete } from '../common/'
import classNames from 'classnames'
import bindAllActions from '../../common/bindAllActions'
import {
  MyTimeline
} from './'

const DefaultPage = ({ device, user, social, match, deviceActions }) => {
  const { mapLocation, setMapLocation } = useSetMapLocation()
  const { doModal } = useDoModal()
  const { allPosts } = social
  const [scrolled, setScrolled] = useState(false)
  const [tab, setTab] = useState('all')
  const [fetchedDevice, setFetchedDevice] = useState(null)
  const [deviceNotFound, setDeviceNotFound] = useState(false)
  const slug = path(['params', 'key'], match)
  const postId = path(['params', 'postId'], match)

  useEffect(() => {
    const hash = path(['location', 'hash'], window)
    if (!hash || scrolled) return

    const el = document.getElementById(hash.replace('#', ''))
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      })
      setScrolled(true)
    }
  }, [allPosts, setScrolled, scrolled])

  useEffect(() => {
    // Skip device fetching if we're viewing a single post
    if (postId) {
      setFetchedDevice(null)
      setDeviceNotFound(false)
      return
    }

    if (!slug) {
      setFetchedDevice(null)
      setDeviceNotFound(false)
      return
    }

    // Check user's devices first
    const myDevice = device.devices && device.devices.find(d => getDeviceSlug(d) === slug)
    if (myDevice) {
      setFetchedDevice(myDevice)
      setDeviceNotFound(false)
      return
    }

    // Fetch public device if not in user's list
    if (!device.fetchDevicePending) {
      deviceActions.fetchDevice({ 'public.slug': slug })
        .then(res => {
          deviceActions.clearFetchedDevices()
          if (res.data && res.data[0]) {
            setFetchedDevice(res.data[0])
            setDeviceNotFound(false)
          } else {
            setDeviceNotFound(true)
          }
        })
        .catch((err) => {
          setDeviceNotFound(true)
        })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, device.devices, postId])

  // Show error if device not found
  if (deviceNotFound) {
    return (
      <div className={classNames('social-default-page', 'error')}>
        <header className='main'>
          <h1>Device Not Found</h1>
        </header>
        <p>This device is not available or not public.</p>
      </div>
    )
  }

  const myTimelineProps = {
    onTabChange: setTab,
    geo: fetchedDevice ? null : path(['geo'], mapLocation),
    currentDevice: fetchedDevice,
    isSocialPage: true,
    postId
  }

  return (
    <div className={classNames('social-default-page', tab, {
      'device-view': fetchedDevice,
      'single-post-view': postId
    })}>
      <header className='main'>
        <h1>
          Social
        </h1>
      </header>
      {!fetchedDevice && (
        <LocationAutocomplete
          placeholder={getMapLocationLabel(mapLocation)}
          onPlaceSelected={setMapLocation}
        />
      )}
      <MyTimeline {...myTimelineProps} />
      {userCanSocialPost(user, device) &&
        <a
          className='create-post-btn'
          onClick={() => {
            doModal({
              type: 'create-post'
            })
          }}
        />}
    </div>
  )
}

export default bindAllActions(withRouter(DefaultPage))

DefaultPage.displayName = 'DefaultPage'
